import React, {useEffect, useState} from 'react';

const HVACIcon = ({className, ordinal, openModal}) => {
  return (
    <button className={"hvac " + className} onClick={openModal}>
      <span className={"fa-stack"}>
        <i className="fa fa-stop fa-stack-2x"/>
        <i className="fa fa-fan fa-stack-1x fa-inverse"/>
      </span>
      <span className="hvac-text">{ordinal}</span>
    </button>
  )
}

export const HVAC = ({carNumber, ConditionService, $uibModal}) => {
  const [hvacs, setHvacs] = useState([]);

  async function fetchData() {
    const assetFilter = {
      assetType: 'HVAC-CONTROLLER'
    };
    const response = await fetch('/service/condition/latest/cars?carIds=' + carNumber,
      {method: 'POST', body: JSON.stringify(assetFilter), headers: {"Content-Type": "application/json",}});
    return await response.json();
  }

  const loadHvac = async () => {
    const hvacData = await fetchData();
    hvacData.forEach(car => {
      car.bogies.forEach(hvac => { // Returned data model currently uses bogies for root asset
        hvac.categories.forEach(category => {
          category.assets.forEach(asset => {
            if (asset.ci_values != null) {
              asset.ci_values.map(ci => {
                ci.latestValue = _.last(ci.results).value;
              });
            }
          });
        });
      });
    });
    setHvacs(hvacData[0].bogies);
  };

  useEffect(() => {
    loadHvac();
  }, []);

  const hvacOrientation = (hvac) => {
    let classNames = "";
    if (hvac.ordinal % 2) {
      classNames = 'hvac-right ';
    } else {
      classNames = 'hvac-left ';
    }
    classNames += hvac.status.toLowerCase();
    return classNames;
  }

  const openSubsystemModal = (hvac) => () => {
    const subSystemObject = {
      name: hvacs[0].name,
      cis: hvac.ci_values,
      assets: [hvac],
      carNumber,
    };
    const modalInstance = $uibModal.open({
      component: 'subsystemModal',
      windowClass: 'subSystemWindow',
      resolve: {
        subSystemObject: function () {
          return subSystemObject;
        },
      },
    });

    modalInstance.result.then(() => {
    }, () => {
    });
  };

  if (!hvacs.length) {
    return <></>
  }
  return (
    <div className={"hvac-system"}>
      {hvacs[0].categories[0].assets.map(hvac =>
        <HVACIcon key={"hvac-" + hvac.ordinal}
                  ordinal={hvac.ordinal}
                  className={hvacOrientation(hvac)}
                  openModal={openSubsystemModal(hvac)}/>
      )}
    </div>
  )
}